module.exports = __webpack_public_path__ + "static/media/groq.d224ed4b.svg";